import { create } from "zustand";
import { persist } from "zustand/middleware";

import { INightReportFilterSettings } from "interfaces/nightReport.interface";

type MonitoringState = {
  isFullscreen: boolean;
  scale: number;
  selectedZoneIds?: string[];
  nightReportFilter: INightReportFilterSettings;

  setIsFullscreen: (isFullscreen: boolean) => void;
  setScale: (scale: number) => void;
  setSelectedZoneIds: (zones?: string[]) => void;
  setNightReportFilter: (filter?: INightReportFilterSettings) => void;
};

export const useMonitoringStore = create<MonitoringState>()(
  persist(
    (set) => ({
      isFullscreen: !!document.fullscreenElement,
      scale: 10,
      selectedZoneIds: undefined,
      nightReportFilter: {
        showOnlyBadNights: false,
      },
      setIsFullscreen: (isFullscreen) => set({ isFullscreen }),
      setScale: (scale) => set({ scale }),
      setSelectedZoneIds: (zoneIds) => set({ selectedZoneIds: zoneIds }),
      setNightReportFilter: (filter) =>
        set({
          nightReportFilter: filter ?? { showOnlyBadNights: false },
        }),
    }),
    {
      name: "monitoring-store",
      version: 1,
    },
  ),
);
